export default function AboutPage() {
  return (
    <div>
      <section className="relative h-[55vh] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1611021061285-16c871740efa" className="absolute inset-0 w-full h-full object-cover" alt=""/>
        <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/70 to-transparent"/>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 h-full flex items-end pb-12 text-white">
          <div>
            <p className="eyebrow text-[#E7D3B3]">Our Story</p>
            <h1 className="font-serif text-5xl md:text-7xl mt-2 tracking-tight">Wood, patience, and a family name.</h1>
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 md:px-12 py-20">
        <p className="text-xl text-stone-700 leading-relaxed">Vardhman began as a modest workshop tucked away in a lane where the aroma of freshly cut Sheesham lingered in the evening air. Three generations later, that same lane is still ours — but the pieces we build now travel further than we ever imagined.</p>
        <p className="mt-6 text-stone-600 leading-relaxed">We believe furniture is memory made tangible. The desk you write your novel on. The dining table where your children learn to hold a spoon. We build with that responsibility in mind.</p>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          {[
            { t: "Seasoned Timber", d: "Every board is dried for months before it earns a place in our workshop." },
            { t: "Hand Joinery", d: "Dovetails, mortise-and-tenon, hand-cut. No shortcuts on structure." },
            { t: "Natural Finishes", d: "Oils and waxes only — never toxic lacquers. The grain deserves to breathe." },
          ].map((v) => (
            <div key={v.t}>
              <p className="eyebrow">Craft</p>
              <h3 className="font-serif text-2xl mt-2">{v.t}</h3>
              <p className="mt-2 text-stone-600 text-sm leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
